module.exports = __webpack_public_path__ + "media/images/map/eole-e1ec1abcf69b24a848957f2788d4517f.png";